import React, { useState } from 'react';

import Nav from './Nav';
import {Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';
import logo from "../images/logo.svg";
import profilePic from '../images/pic.jpg';
import resume from "./pdf/Resume_JoaoCosta.pdf"
// import resume from "../pdf/Resume_JoaoCosta.pdf"
class Resume extends React.Component {
 

    componentDidMount() {
        window.scrollTo(0, 0)
        window.addEventListener('scroll', this.onScroll, true);
      }


  render(){ 
    
     
          return (
                <React.Fragment>

  

{/* <Link target="_blank"  to="" type="application/pdf" download="../pdf/Resume_JoãoCosta.pdf"> */}
{/* <Link target="_blank"  href={require("../pdf/Resume_JoãoCosta.pdf")} type="application/pdf" > */}
        <a href={resume} target="blank">
            <button className="bt resumePdf">Download Resume</button>
        </a>  
        {/* </Link> */}




        <Fade top cascade >
                <div className="nav">
                    
                   <div>
                       <Link to="/">
                       <img className="logo" src={logo} alt=""/>
                       </Link>
                      
                   </div>
                  
                   
                </div>
                </Fade>







<div className="hero">
 
</div>
<div className="mainWrapper resumeContent">
<Fade cascade big delay={200}>
        <h2 className="h2">Experience</h2>

                <div className="resumeItem">
                    <div className="smallTextLeft">2020 - present</div>
                    <div className="activity">
                        <p>Erasmus Internship</p>
                        Product Designer & Front-end Developer, <br/> VivaDrive
                        <p>At VivaDrive I work with the design team developing the UI/UX of the products, doing user tests, prototyping, research, marketing. <br/>  I am also part of the development team as front end developer using ReactJS.</p>
                    </div>
                    <div className="location">Warsaw, <br/> Poland 🇵🇱</div>
                </div>

                <div className="resumeItem">
                    <div className="smallTextLeft">2018 - 2019</div>
                    <div className="activity">
                        UI/UX Designer & FrontEnd Developer, <br/> Lim9
                        <p>Worked as graphic, UI/IX designer, product prototyping, 3d modelling, creating social media content, in a way a full stack designer. <br/> 
                            As for development i was doing front-end development using HTML,CSS, JS and Jquery, focusing on replicating the designs i developed, responsible layouts and fast loading time.
                        </p>
                    </div>
                    <div className="location">Madeira, <br/> Portugal 🇵🇹</div>
                </div>

        <h2 className="h2">Education</h2>

                <div className="resumeItem">
                    <div className="smallTextLeft">2018 - present</div>
                    <div className="activity">

                    Master of Interactive Media Design at
 <br/> Universidade da Madeira
 <p>In my thesis I am studying <strong>the impact of augmented reality in educational systems </strong>  and how can it improve motivation and learning capabilities of students and also make the task easier for teachers. <br/>
            In this project the augmented reality application has a status of 80% as all the algorithms are developed and is missing just feedback and testing to get results.</p>
 </div>

          
    <div className="location">Madeira, <br/> Portugal 🇵🇹</div>

                </div>

                <div className="resumeItem">
                    <div className="smallTextLeft">2015-2018</div>
                    <div className="activity">
                    Design Bachelor at  <br/> Universidade da Madeira</div>
                    <div className="location">Madeira, <br/> Portugal 🇵🇹</div>
                </div>

        <h2 className="h2">About</h2>

    <div className="aboutText">
        <div className="smallTextLeft"></div>
        <div className="activity about">
        I am João, a student and product designer striving to make products easier to use and accessible to everyone.</div>
    <div className="mePic">
            <img src={profilePic} alt=""/>
            </div>
    </div> 



<h2 className="h2">Skills</h2>

<div className="resumeItem5050">
    <div className="smallTextLeft">Design</div>
    <div className="activity">
<h3>Design Thinking</h3>
<h3>UI/UX</h3>
<h3>Prototyping</h3>
<h3>User Centered Design</h3>
<h3>Testing</h3>
<h3>Photoshop</h3>
<h3>Illustrator</h3>
<h3>Sketch</h3>
<h3>Adobe XD</h3>
    </div>
    <div className="smallTextLeft">Programming</div>
    <div className="activity">
<h3>HTML</h3>
<h3>CSS</h3>
<h3>Javascript</h3>
<h3>ReactJS</h3>
<h3>Swift</h3>
    </div>



</div> 

</Fade>
<div className="spacer"></div>

           
    </div>

      


    <div className="footer">
            <div className="section">
            <Fade delay={200}>
                <h1 className="filledHeading">
                    Interested in working with me or know more about my projects?
                </h1>
                </Fade>
                {/* <Fade  delay={200}> */}
                <div className="socials">
                    <a href="mailto:joaocostajjsc@gmail.com" target="_blank">
                    <img src="/img/email.svg" alt=""/>
                    </a>
                    <a href="https://github.com/joaocostajs" target="_blank">
                    <img src="/img/github.svg" alt=""/>
                    </a>
                    <a href="https://twitter.com/joaocostajjsc" target="_blank">
                    <img src="/img/twitter.svg" alt=""/>
                    </a>
                    <a href="https://www.instagram.com/joaojscosta/" target="_blank">
                    <img src="/img/insta.svg" alt=""/>
                    </a>
                </div>

              
                {/* </Fade> */}
            </div>
           
            </div>
                        
                     

                </React.Fragment>
            )
    } }

export default Resume;